import React, { useContext, useState } from 'react';
import { Layout, Typography, Button, Modal } from 'antd';
import { MenuOutlined, LogoutOutlined } from '@ant-design/icons';
import { useMediaQuery } from '@react-hook/media-query';
import { AuthContext } from '../context/AuthContext';

const { Header } = Layout;
const { Title } = Typography;

function HeaderComponent({ toggleSidenav }) {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const { isLoggedIn, logout } = useContext(AuthContext);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    logout();
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <Header style={{ backgroundColor: '#318fe0', color: '#fff', padding: '8px', textAlign: 'center', display: 'flex', alignItems: 'center' }}>
      {isMobile && isLoggedIn ? (
        <>
          <Button
            type="primary"
            onClick={toggleSidenav}
            icon={<MenuOutlined />}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#318fe0',
              borderColor: '#fff',
              color: '#fff',
              marginLeft: 0,
            }}
          />
          <Title level={3} style={{ margin: 0, color: '#fff', marginLeft: 'auto', marginRight: 'auto' }}>Next Airtime</Title>
        </>
      ) : (
        <Title level={3} style={{ margin: 0, color: '#fff', marginLeft: 'auto', marginRight: 'auto' }}>Next Airtime</Title>
      )}
      {isLoggedIn && (
        <>
          <Button
            type="text"
            icon={<LogoutOutlined />}
            onClick={showModal}
            style={{
              color: '#fff',
              marginLeft: '16px',
            }}
          >
            Logout
          </Button>
          <Modal
            title="Confirm Logout"
            visible={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            className="logout-modal"
          >
            <p>Are you sure you want to logout?</p>
          </Modal>
        </>
      )}
    </Header>
  );
}

export default HeaderComponent;
